module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/10-8a954a1f18439eae1911b1f2845a81aa.jpg";